import { useTranslation } from "react-i18next";
import bg_top from "../../assets/images/icons/bg-top.svg";
import { GeneralButton } from "../../components";

const UserBlocked = () => {
  const { t } = useTranslation();
  return (
    <div className="p-4 lg:p-6">
      <img className="w-full" src={bg_top} alt="bg" />
      <div className="mt-52 flex flex-col items-center justify-center gap-4">
        <h2 className="text-center text-3xl font-bold lg:whitespace-nowrap">
          {t("number_blocked")}
        </h2>
        <p className="text-body-text max-w-2xl text-center">
          {t("number_blocked_msg")}
        </p>
        <GeneralButton route="/login" title={t("contact_us")} />
      </div>
    </div>
  );
};

export default UserBlocked;
